'use client';

import { useIsMounted, useSelector } from '@legendapp/state/react';
import { type ComponentProps } from 'react';
import NextLink from 'next/link';
import { jucyAttribution } from '@/lib/jucyAttribution';

export type LinkProps = ComponentProps<typeof NextLink>;

export function Link({ href, className, children, ...props }: LinkProps) {
    const mounted = useSelector(useIsMounted());
    const internalHref = mounted && href ? jucyAttribution.decorateUrl(`${href}`) : href;

    if (!internalHref) {
        return <span className={className}>{children}</span>;
    }

    return (
        <NextLink href={internalHref} className={className} {...props}>
            {children}
        </NextLink>
    );
}
